module.exports = __webpack_public_path__ + "static/media/refer-a-friend-popup.27ac42d1.png";